import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from 'react-bootstrap';
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const AssignmentStore = require('../../stores/AssignmentStore');
const AssignmentActions = require('../../actions/AssignmentActions');
import SortableTableClassic from '../table/SortableTableClassic';
// import JsonTextArea from '../common/JsonTextArea';
import SendScoreErrorBlock from './SendScoreErrorBlock';
import ErrorBox from '../common/ErrorBox';
import WarningBox from '../common/WarningBox';
import SuccessBox from '../common/SuccessBox';

const propTypes = {};
const defaultProps = {};

class AdminSendScoreErrorsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            assignmentStoreState: AssignmentStore.getState(),
            selectedErrorId: null,
            newTokenName: "",
            newTokenDescription: "",
            resendActionId: null,
            retryError: null
        }

        this.onErrorClick = this.onErrorClick.bind(this);
        this.refreshErrors = this.refreshErrors.bind(this);
        this.refreshError = this.refreshError.bind(this);
        this.resendScoreConnect = this.resendScoreConnect.bind(this);
        this.unsubscribes = [AssignmentStore.listen(this.onAnalyticsStoreChange.bind(this))];
    }

    componentDidMount() {
        this.refreshErrors();
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onAnalyticsStoreChange(state) {
        let additionalState = {};
        if (state.action.id === this.state.resendActionId) {
            additionalState = { ...additionalState, resendActionId: null };
            if (state.action.error) {
                additionalState = { ...additionalState, retryError: state.action.error };
            }
        }
        


        this.setState({ assignmentStoreState: state, ...additionalState });
    }

    onErrorClick(e, u2aId) {
        this.setState({ selectedErrorId: u2aId, retryError: null });
    }

    refreshErrors() {
        AssignmentActions.getAdminSendScoresErrors(uuid.v4());
    }

    refreshError(userAttemptId) {
        AssignmentActions.getAdminSendScoresError(uuid.v4(), { userAttemptId: userAttemptId });
    }

    resendScoreConnect() {
        if (
            !this.state.selectedErrorId
            || !this.state.assignmentStoreState
            || !this.state.assignmentStoreState.adminSendScoreErrors
        ) {
            return;
        }

        const record = this.state.assignmentStoreState.adminSendScoreErrors.find(e => e.user_attempt_id === this.state.selectedErrorId);

        if (!record) {
            return;
        }

        const resendId = uuid.v4();
        this.setState(
            { resendActionId: resendId },
            AssignmentActions.resendConnectAssignmentScore(
                resendId,
                {
                    assignmentHash: record.assignment_hash,
                    studentId: record.user_id,
                    attemptId: record.attempt_id,
                }
            )
        );
    }

    render() {
        const self = this;
        if (
            !this.state.assignmentStoreState
            || !this.state.assignmentStoreState.adminSendScoreErrors
        ) {
            return null;
        }

        let selectedErrorRecord = null;
        if (this.state.selectedErrorId) {
            selectedErrorRecord = this.state.assignmentStoreState.adminSendScoreErrors.find(e => e.user_attempt_id === this.state.selectedErrorId);
        }

        return (
            <div>
                <button
                    className="bare-text-button glyph fr"
                    title="Refresh All Error Info"
                    onClick={this.refreshErrors}
                >
                    <span className="fa fa-refresh" aria-hidden="true"/>
                </button>

                <SortableTableClassic
                    key="raw-data-table"
                    title="Send Score Errors"
                    uniqueRowKey="user_attempt_id"
                    onRowClick={this.onErrorClick}
                    rows={this.state.assignmentStoreState.adminSendScoreErrors}
                    selectedRowKey={this.state.selectedErrorId}
                    columns={[
                        {
                            displayName: 'U2A ID',
                            key:'user_attempt_id',
                            size: 1,
                            type: 'int'
                        },
                        {
                            displayName: 'Email',
                            key:'user_third_party_email',
                            size: 1,
                            type: 'string'
                        },
                        {
                            displayName: 'Attempt ID',
                            key:'attempt_id',
                            size: 1,
                            type: 'string'
                        },
                        {
                            displayName: 'Integration Type',
                            key: 'integration_type',
                            size: 1,
                            type: 'string'
                        },
                        {
                            displayName: 'Assignment Hash',
                            key:'assignment_hash',
                            size: 2,
                            type: 'string'
                        },
                        {
                            displayName: 'Status Date',
                            key:'status_date',
                            size: 2,
                            type: 'date'
                        }
                    ]}
                />

                {(!!selectedErrorRecord) &&
                    <div>
                        <h3 className="view-title margin-top-lg">
                            Error Attempt Info
                            <button
                                className="bare-text-button glyph margin-left-md"
                                title="Refresh Error Info"
                                onClick={this.refreshError.bind(this, this.state.selectedErrorId)}
                            >
                                <span className="fa fa-refresh" aria-hidden="true" />
                            </button>
                        </h3>
                        <SendScoreErrorBlock sendScoreError={selectedErrorRecord} />
                        <h3 className="view-title margin-top-lg">Attempt to Re-Send Score</h3>
                            {(!!selectedErrorRecord.resend_success) ?
                                <SuccessBox>Score successfully resent!</SuccessBox>
                                :
                                <Card body bg="light">
                                    <WarningBox>
                                        {`Attempts to automatically resend score to LMS.`}
                                    </WarningBox>
                                    <ErrorBox allowStackTrace error={this.state.retryError} />
                                    {selectedErrorRecord.integration_type === Globals.integration_type.CONNECT &&
                                        <Button
                                            variant="danger"
                                            disabled={!!this.state.resendActionId}
                                            onClick={this.resendScoreConnect}
                                        >
                                            Resend score to Connect
                                        </Button>
                                    }
                                    {(selectedErrorRecord.integration_type === Globals.integration_type.LTI
                                        || selectedErrorRecord.integration_type === Globals.integration_type.LOCAL
                                        || selectedErrorRecord.integration_type === Globals.integration_type.GOOGLE_CLASSROOM) &&
                                        <Button variant="danger" disabled>
                                            Resend score not available for this Integration Type
                                        </Button>
                                    }
                                </Card>
                            }
                    </div>
                }
            </div>
        );
    }
}

AdminSendScoreErrorsView.propTypes = propTypes;
AdminSendScoreErrorsView.defaultProps = defaultProps;

export default AdminSendScoreErrorsView;